export const address = {
    addressForm: {
        userAddressAddSuccess: 'New address was added successfully!',
        userAddressUpdateSuccess: 'Address updated successfully!',
        userAddressDeleteSuccess: 'Address deleted successfully!',
    }
};
